const storageFilters = [
  {
    title: "Atendente",
    exhib: false,
  },
  {
    title: "Ramal",
    exhib: false,
  },
  {
    title: "Grupo",
    exhib: true,
  },
  {
    title: "Tempo Logado",
    exhib: true,
  },
  {
    title: "Canais",
    exhib: true,
  },
  {
    title: "Pausa Futura",
    exhib: true,
  },
  {
    title: "Tempo Pausa Futura",
    exhib: true,
  },
  {
    title: "Status",
    exhib: true,
  },
  {
    title: "Tempo do Status",
    exhib: true,
  },
  {
    title: "Realizadas Voz",
    exhib: true,
  },
  {
    title: "Atendidas Voz",
    exhib: true,
  },
  {
    title: "Transf Voz",
    exhib: true,
  },
  {
    title: "CSAT Voz",
    exhib: true,
  },
  {
    title: "Realizadas Digital",
    exhib: true,
  },
  {
    title: "Atendidas Digital",
    exhib: true,
  },
  {
    title: "Transf Digital",
    exhib: true,
  },
  {
    title: "CSAT Digital",
    exhib: true,
  },
  {
    title: "Tempo",
    exhib: true,
  },
  {
    title: "Qtde Telas",
    exhib: true,
  },
  {
    title: "Em Atendimento",
    exhib: true,
  },
  {
    title: "Pendente",
    exhib: true,
  },
  {
    title: "Finalizados",
    exhib: true,
  },
];

const initialState = localStorage.getItem("filters_manager_columns_operators");
let initialJson = storageFilters;

if (initialState) {
  let newColumns = storageFilters;
  let initialJson = JSON.parse(
    localStorage.getItem("filters_manager_columns_operators")
  );
  for (const column of initialJson) {
    if (column && Object.keys(column).length > 0) {
      const findColumn = newColumns.find(
        (columnEx) => columnEx.title === column.title
      );
      if (findColumn) {
        findColumn.exhib = column.exhib;
      }
    }
  }
}

const columnsalloperators = (state = initialJson, action) => {
  switch (action.type) {
    case "CHANGE_COLUMNS_ALL_OPERATORS":
      return action.columns;

    default:
      return state;
  }
};

export default columnsalloperators;
